const shadows = {
  0: "none",
  /* shadow/xs */
  1: "0px 1px 2px 0px rgba(36, 5, 5, 0.08)",
  /* shadow/sm */
  2: "0px 1px 3px 0px rgba(36, 5, 5, 0.10), 0px 1px 2px 0px rgba(36,5,5,0.06)",
  /* shadow/md */
  3: "0 6px 8px -2px rgba(36, 5, 5, 0.12), 0 2px 4px -2px rgba(36, 5, 5, 0.06)",
  /* shadow/lg */
  4: "0 12px 16px -4px rgba(36, 5, 5, 0.12), 0 4px 6px -2px rgba(36, 5, 5, 0.06)",
  /* shadow/xl */
  5: "0 20px 24px -4px rgba(36, 5, 5, 0.12), 0 8px 8px -4px rgba(36, 5, 5, 0.06)",
  /* shadow/2xl */
  6: "0 24px 48px -12px rgba(36, 5, 5, 0.20)",
  /* shadow/3xl */
  7: "0 32px 64px -12px rgba(36, 5, 5, 0.20)"
};
export {
  shadows
};
